import { toast } from "react-toastify";

export const showNoPermissionToast = () => {
  toast.error("🚫 You do not have permission to perform this action!", {
    position: "top-right",
    autoClose: 3000,
  });
};

export const showSuccessToast = (message: string) => {
  toast.success(message, {
    position: "top-right",
    autoClose: 3000,
  });
};

export const showErrorToast = (message: string) => {
  toast.error(message, {
    position: "top-right",
    autoClose: 3000,
  });
};
